<template>
  <div class="reconcoloation-filters">
    <e-input v-model="filters.searchString" debounced label="Поиск" class="reconcoloation-filters__input">
      <template #append-inner>
        <e-icon name="search" size="20" />
      </template>
    </e-input>

    <template v-if="!$vuetify.display.smAndDown">
      <e-select
        v-model="filters.mounth"
        label="Отчётный месяц"
        class="reconcoloation-filters__input"
        :items="mounthItems"
      />
      <e-select
        v-model="filters.status"
        label="Статус"
        class="reconcoloation-filters__input"
        clearable
        :items="statusItems"
      />
    </template>

    <filters-dialog v-else v-model="filters" :default-filters="defaultReconciliationFilter">
      <template #default="props">
        <e-input v-model="props.items.searchString" debounced label="Поиск" class="mb-4">
          <template #append-inner>
            <e-icon name="search" size="20" />
          </template>
        </e-input>
        <e-select v-model="props.items.mounth" label="Отчётный месяц" :items="mounthItems" class="mb-4" />
        <e-select v-model="props.items.status" label="Статус" clearable :items="statusItems" />
      </template>
    </filters-dialog>
  </div>
</template>

<script lang="ts" setup>
import { toRef, watch } from 'vue';
import { getReconciliationDefaultFilters } from '../utils';
import type { ReconciliationFilters } from '../types';
import FiltersDialog from '@/core/components/common/FiltersDialog.vue';
import { EIcon, EInput, ESelect } from '@/core/components/ui';
import { getMonthNameWithYear } from '@/core/utils/date';
import { OrderReconciliationStatus } from '@/graphql/generated';
import { useReconciliationStore } from '@/parts/reconciliation/store';

const { reconciliationFilters } = useReconciliationStore();

const filters = defineModel<ReconciliationFilters>({
  required: true,
});

const mounthItems = toRef(
  () =>
    reconciliationFilters.value?.reportDates.map((date) => ({
      title: getMonthNameWithYear(date.reportDate),
      value: date.reportDate,
    })) || [],
);

const defaultReconciliationFilter = () => getReconciliationDefaultFilters(mounthItems.value[0]?.value);

const statusItems = [
  {
    title: 'Есть расхождения',
    value: OrderReconciliationStatus.Mismatch,
  },
  {
    title: 'Требует сверки',
    value: OrderReconciliationStatus.NotReconciled,
  },
  {
    title: 'Сверено',
    value: OrderReconciliationStatus.Reconciled,
  },
  {
    title: 'Сверено Алеан',
    value: OrderReconciliationStatus.ReconciledByAlean,
  },
];

watch([() => filters.value.mounth, () => filters.value.status, () => filters.value.searchString], () => {
  filters.value.pagination.page = 1;
});
</script>

<style lang="scss" scoped>
.reconcoloation-filters {
  display: flex;
  gap: 16px;

  &__input {
    max-width: 280px;

    @include md-and-down {
      max-width: 100%;
    }
  }
}
</style>
